/* eslint-disable linebreak-style */
/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import getConfig from 'next/config';
import Slider from 'base-ui/dist/Slider';
import { useAmp } from 'next/amp';
import PostCard from 'components/PostCard';
import { useAuth } from 'root/hooks/useAuth';
import apiClient from '../../lib/apiClient';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const FeaturedPosts = ({ widget }) => {
  const { stateUser } = useAuth();
  const { isAuthenticated } = stateUser;
  const [bookmarks, setBookmarks] = useState([]);

  const widget_type = parseInt(widget.options.widget_type, 10);

  useEffect(() => {
    const getBookmarks = async () => {
      const result = await apiClient({ baseURL: publicRuntimeConfig.BASE_API_URL, method: 'GET', url: '/bookmarks/ids' });

      if (result.length > 0) setBookmarks(result.map(({ id }) => id));
    };

    if (isAuthenticated) {
      getBookmarks();
    }
  }, [isAuthenticated]);

  if (widget_type === 1) {
    return (
      <div className="widget widget-interesting">
        <div className="section-title text-uppercase align-center small utilitary-border utilitary-color">
          <span
            className="label"
            dangerouslySetInnerHTML={{
              __html: widget.options.title
            }}
          />
        </div>
        <div className="horizontal-scroll-md posts-row">
          {widget.content.map((post, index) => (
            <PostCard
              key={post.id}
              post={post}
              big={index === 0}
              lazy
              height={{ desktop: '223px', mobile: '145px' }}
              isAuthenticated={isAuthenticated}
              bookmarks={bookmarks}
              handleBookmarks={setBookmarks}
            />
          ))}
        </div>
      </div>
    );
  }

  if (widget_type === 2) {
    return (
      <section className="widget">
        <div className="section-title main-border">
          <span
            className="label text-uppercase titles-color"
            dangerouslySetInnerHTML={{
              __html: widget.options.title
            }}
          />
        </div>
        { useAmp() ? (
          <amp-carousel
            height="240"
            layout="fixed-height"
            type="slides"
          >
            {widget.content.map((post) => (
              <PostCard
                key={post.id}
                post={post}
                type="slide"
                isAuthenticated={isAuthenticated}
                bookmarks={bookmarks}
                handleBookmarks={setBookmarks}
              />
            ))}
          </amp-carousel>
        ) : (
          <Slider
            className="category-slider big posts-row"
            dots
            slidesToShow={1}
            slidesToScroll={1}
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 3,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 2,
                  initialSlide: 2
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]}
          >
            {widget.content.map((post) => (
              <PostCard
                key={post.id}
                post={post}
                isAuthenticated={isAuthenticated}
                bookmarks={bookmarks}
                handleBookmarks={setBookmarks}
              />
            ))}
          </Slider>
        )}
      </section>
    );
  }

  return (
    <section
      className={`widget ${widget.options.widget_class}`}
    >
      <div className="section-title main-border">
        <span
          className="label text-uppercase titles-color"
          dangerouslySetInnerHTML={{
            __html: widget.options.title
          }}
        />
      </div>

      <div className="posts-row">
        {widget.content.map((post, index) => (
          <PostCard
            key={post.id}
            post={post}
            big={index === 0}
            isAuthenticated={isAuthenticated}
            bookmarks={bookmarks}
            handleBookmarks={setBookmarks}
          />
        ))}
      </div>
    </section>
  );
};

FeaturedPosts.propTypes = {
  widget: PropTypes.object,
};

export default FeaturedPosts;
